import { FC } from 'react';
import { useForm } from 'react-hook-form';
import { StyledButton, StyledInput } from '../styles';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { getInputState } from '@app/utils/getInputState';
import { ERROR_TEXTS } from '@app/constants';
import { actions } from '@app/store';
import { useAppDispatch } from '@app/store/hooks';
import { UserResponseDtoRoleEnum } from '@app/api';
import { useStepperDispatcher } from '@app/components/Stepper';
import { SignUpStepsLabels } from '@app/types';
import { useCheckEmailMutation } from '@app/store/api/auth';
import { sendMetrik } from '@app/utils/sendMetrik';

interface Props {
  role: UserResponseDtoRoleEnum;
}

interface FormData {
  email: string;
}

const schema = yup
  .object({
    email: yup.string().email(ERROR_TEXTS.email).required(ERROR_TEXTS.required),
  })
  .required();

const EmailForm: FC<Props> = ({ role }) => {
  const dispatch = useAppDispatch();
  const { switchStep } = useStepperDispatcher();
  const [checkEmail] = useCheckEmailMutation();
  const {
    register,
    handleSubmit,
    setError,
    formState: { errors, isDirty, isValid, isSubmitting, dirtyFields },
  } = useForm<FormData>({
    mode: 'onChange',
    resolver: yupResolver(schema),
    delayError: 500,
  });

  const onSubmit = handleSubmit(async (data) => {
    const { isAvailable } = await checkEmail({
      email: data.email,
      isNeedVerification: false,
    }).unwrap();
    sendMetrik('reachGoal', 'create_account');

    if (!isAvailable) {
      setError('email', { message: ERROR_TEXTS.emailIsNotAvailable });
      return false;
    }

    dispatch(
      actions.auth.setSignUpContext({
        type: 'email',
        value: data.email,
        role: role,
      }),
    );

    switchStep(SignUpStepsLabels.createPassword);
  });

  return (
    <>
      <form onSubmit={onSubmit}>
        <div>
          <StyledInput
            autoFocus
            type="email"
            label="Адрес электронной почты"
            placeholder="example@gmail.com"
            inputState={getInputState(dirtyFields, errors, 'email')}
            textError={errors.email?.message}
            isError={Boolean(errors.email?.message)}
            {...register('email')}
          />
          <StyledButton
            styleType="primary"
            isLoading={isSubmitting}
            isLarge
            isDisabled={!isDirty || !isValid}
          >
            Создать аккаунт
          </StyledButton>
        </div>
      </form>
    </>
  );
};

export default EmailForm;
